import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description"];
import { fetchDocuments } from './fetchDocuments';
import { renderDocument } from './renderDocuments';
import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { searchEntriesRpc, listEntriesRpc } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentIndexRpc';
import { mapDocumentEntry } from './mapDocumentEntry';
export const documentsApiWrapper = (httpClient, contactEmail) => ({
  fetchRenderedContent({
    id
  }) {
    return renderDocument({
      httpClient,
      contentId: id,
      contactEmail
    }).then(linkInfo => {
      const {
        url,
        text
      } = linkInfo;
      return {
        htmlBody: `<a href="${url}">${text}</a>`
      };
    });
  },
  searchArticles({
    query,
    count
  }) {
    return fetchDocuments({
      httpClient,
      queryParams: {
        query
      }
    }).then(results => {
      const finalResults = count ? results.slice(0, count) : results;
      return finalResults.map(item => {
        return Object.assign({}, item, {
          value: item.id
        });
      });
    });
  }
});

// TODO(SalesDocumentsCHIRPMigration cleanup): delete along with `searchDocuments`,
// `fetchDocuments`, and `normalizeRestDocument`. Only the REST path carries the
// JSON-encoded `description`; CHIRP delivers `brandId` first-class.
export const normalizeRestDocument = r => {
  const {
      description
    } = r,
    rest = _objectWithoutPropertiesLoose(r, _excluded);
  let brandId;
  if (description) {
    try {
      const parsed = JSON.parse(description);
      if ((parsed === null || parsed === void 0 ? void 0 : parsed.brandId) != null) brandId = Number(parsed.brandId);
    } catch (_unused) {
      // malformed description — treat as no brand
    }
  }
  return Object.assign({}, rest, {
    brandId
  });
};
export function fetchDocument(id) {
  return http.get(`presentations/v1/deck/${id}`).then(fromJS);
}
export function createDocumentLink(documentId, skipForm, sharedWith) {
  return http.post(`presentations/v1/deck/${documentId}/share`, {
    query: {
      isLive: true,
      skipForm,
      sharedWith
    }
  }).then(fromJS);
}
export function searchDocuments(searchInput) {
  return http.post('/salescontentsearch/v2/search', {
    data: {
      contentTypesToHydrate: ['DOCUMENT', 'DOCUMENTS_FOLDER'],
      filters: [{
        field: 'content_type',
        values: ['DOCUMENT']
      }],
      limit: 100,
      offset: 0,
      query: searchInput
    }
  }).then(res => Object.assign({}, res, {
    results: res.results.map(normalizeRestDocument)
  }));
}
const CHIRP_SEARCH_LIMIT = 100;
export async function searchDocumentsCHIRP(searchInput) {
  var _response$results;
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const hasQuery = searchInput.length > 0;
  const response = hasQuery ? await rpcClient.call(searchEntriesRpc, {
    request: {
      query: searchInput,
      entryTypes: ['DOCUMENT'],
      filters: [],
      folderScope: 'ALL',
      pageLength: CHIRP_SEARCH_LIMIT,
      offset: 0
    }
  }) : await rpcClient.call(listEntriesRpc, {
    request: {
      entryTypes: ['DOCUMENT'],
      filters: [],
      folderScope: 'ALL',
      pageLength: CHIRP_SEARCH_LIMIT,
      offset: 0
    }
  });
  const results = ((_response$results = response.results) !== null && _response$results !== void 0 ? _response$results : []).map(mapDocumentEntry).filter(item => item !== null);
  return {
    total: results.length,
    offset: response.offset,
    results
  };
}